import React, { Component }     from "react";
import uniqueId                 from 'lodash/uniqueId';
import { Button }               from "react-bootstrap";
import Sortable                 from 'react-sortablejs';
import groupBy                  from 'lodash/groupBy';
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import getMeasureTitle          from "../../utils/Measure";
import { ExerciseFreeFormId }   from "../../utils/StaticIds";

export default class SortableDayViewExerciseList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showExerciseDetailRow: this.props.showExerciseDetailRow,
            items: [],
            block_data: []
        }
    }

    componentWillReceiveProps(nextProps) {

    }

    stripAllHTML(html){
       var tmp = document.createElement("DIV");
       tmp.innerHTML = html;
       return tmp.textContent || tmp.innerText || "";
    }

    render() {
        var block_index = this.props.block_index;
        var block_name  = this.props.block_name;
        var week_id     = this.props.week_id;
        var day_id      = this.props.day_id;
        var block_id    = this.props.block_id;
        var exercise    = this.props.exercise;
        var exercise_ids_with_notes   = this.props.exerciseIdsWithNotes;
        var exercise_row= null;
        var ctr = 0;
        //console.log("!!!!!!!!    Sortable Day View    !!!!!!");


        for(var key in exercise) {
            var value = exercise[key];

            exercise_row = Object.keys(exercise).map( index => {
                    var exercise_id     = exercise[index].id;
                    var set_id          = exercise[index].set_id;
                    var exercise_name   = exercise[index].name;
                    var exercise_order  = exercise[index].order;
                    var measure_1_id    = 0; // Static "Sets" title
                    var measure_2_id    = exercise[index].row_2_id;
                    var measure_3_id    = exercise[index].row_3_id;
                    var rest            = exercise[index].rest;
                    var youtube_id      = exercise[index].youtube_id;
                    var advanced_metrics = exercise[index].advanced_metrics;
                    var notes            = exercise[index].notes;

                    if(exercise[index].advanced_metrics != undefined)
                        advanced_metrics = exercise[index].advanced_metrics;

                    var modal_simple_action = "edit"; // edit modal data

                    var details = "";

                    //// Show Notes if a Free-Form Block ////
                    if(exercise_id === ExerciseFreeFormId) {
                        modal_simple_action = "freeFormEditBlock";
                        details             = notes;
                        exercise_name       = "Free-Form: " + this.stripAllHTML(notes);
                    }

                    var exercise_details = <span className="extendExerciseContainer" style={{display: this.state.showExerciseDetailRow}}>
                                                <span dangerouslySetInnerHTML={{__html: details}} />
                                           </span>
                    var notes_icon;
                    var notes_exist = -1;
                    if(exercise_ids_with_notes != "" && exercise_ids_with_notes != undefined)
                        notes_exist = exercise_ids_with_notes.indexOf(exercise_id);

                    if(notes_exist != -1)
                        notes_icon = <FontAwesomeIcon icon="edit" className="" style={{ position:"relative", fontSize:"22px", top:2, paddingLeft: 5, color: "#999" }}/>

                    /*console.log("--------------------------------");
                    console.log("index: " + index);
                    console.log("block_index: " + block_index);
                    console.log("exercise_name: " + exercise_name);
                    console.log("exercise_id: " + exercise_id);
                    console.log("measure_2_id: " + measure_2_id);
                    console.log("measure_3_id: " + measure_3_id);
                    console.log("rest: " + rest);
                    console.log("notes: " + notes);
                    console.log("modal_simple_action: " + modal_simple_action);
                    console.log("advanced_metrics: " + advanced_metrics);
                    console.log("youtube_id: " + youtube_id);*/

                    if(exercise_name)
                        return <div key={uniqueId()}
                                    data-id  = {set_id}
                                    week_id  = {week_id}
                                    day_id   = {day_id}
                                    block_id = {block_id}
                                    set_id   = {set_id}
                                    ex_order = {exercise_order}
                                    ex_id    = {exercise_id}
                                    ex_name  = {exercise_name}
                                >
                                    <div className="exerciseContainer" style={{border:"1px solid #ccc", borderTop:"0px"}} >
                                            <span className="h123Default exerciseNameOverflowEllipsisLong"
                                                  onClick={() => this.props.showDayModalSimple(true, index, block_index, exercise_id, exercise_name, measure_2_id, measure_3_id, rest, notes, modal_simple_action, advanced_metrics, youtube_id)}

                                                  /* this.setState({ showModalSimple: true, exercise_index: index, block_index: block_index,
                                                                  exercise_id: exercise_id, exercise_name: exercise_name, measure_a_id: measure_a_id,
                                                                  measure_a_value: measure_a_value, measure_b_id: measure_b_id, measure_b_value: measure_b_value,
                                                                  rest: rest, notes: notes,  modalSimpleAction: modal_simple_action,
                                                                  advanced_metrics: advanced_metrics })/* */
                                            >
                                                { exercise_name } { notes_icon }
                                            </span>

                                            <span className = "pull-right">
                                                <Button id      = {index}
                                                        onClick = {() => this.props.handleDeleteExercise(block_id, set_id)}
                                                        className = "glyphicon glyphicon-remove adjustDayViewExerciseDeleteBtn ">
                                                </Button>
                                            </span>
                                    </div>
                                    { /*exercise_details*/ }
                                </div>
            })
        }
        return exercise_row;
    }
};

/*Sortable.propTypes = {
    items: React.PropTypes.array,
    onChange: React.PropTypes.func
};*/



// WEBPACK FOOTER //
// ./src/components/sortable/SortableDayViewExerciseList.js